// src/pages/ResetPassword.jsx
import { useState } from 'react';

import FancyButton from '../../components/ui/fancyButton';
import { supabase } from '../../services/supabaseClient/supabaseClient';
import AuthLayout from '../../components/Auth/authLayout';
import { FRONTEND_URL } from '../../apiConfig';

const ResetPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleReset = async () => {
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${FRONTEND_URL}/redirect-reset-password`, // ✅ your custom redirect page
    });
    if (error) {
      setMessage(error.message);
    } else {
      setMessage('Password reset link sent to your email.');
    }
  };

  return (
    <AuthLayout title="Reset Password">
      <input placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
      <FancyButton variant="primary" onClick={handleReset}>
        Send Reset Link
      </FancyButton>
      {message && <p>{message}</p>}
    </AuthLayout>
  );
};

export default ResetPassword;
